const makeSelectAutofilled = form => state => state.form[form].autofilled;

export default makeSelectAutofilled;
